import styled from 'styled-components'

export const Fieldset = styled.fieldset`
  padding: 1rem 0 1rem;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  margin-bottom: 3rem;
`

export const Field = styled.input`
  box-shadow: ${({ isRequiredError }) =>
    isRequiredError && '0 0 0.15rem 0.05rem red'};
  &:focus {
    outline: none;
    box-shadow: ${({ isRequiredError }) =>
      isRequiredError && '0 0 0.3rem 0.1rem red'};
  }
  flex: 1;
  width: ${({ width }) => (width ? width : '10rem !important')};

  margin-left: 0.3rem;
  margin-right: 0.3rem;

  & > label {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 8px;
  }

  & > input, select {
    height: 48px;
    border: 1px solid #c7c9c7;
    box-sizing: border-box;
    border-radius: 4px;

    &[type='date']:invalid {
      color: #757575;
    }

    &:focus {
      outline: 2px solid #2962ff;
    }
  }

   & > select {
     cursor: pointer;
   }

`

export const FieldDescription = styled(Field)`
  flex: 4
`
